import { computed, ref } from 'vue'

export interface StackingProps {
  spacing?: 'between' | 'around' | 'even' | 'center' | number
  align?: 'leading' | 'center' | 'trailing'
  fill: boolean
}

export function useMargin(props: StackingProps) {
  return computed(() => {
    const { spacing } = props
    const margin = ref<string | number | null>(null)

    if (typeof spacing === 'number') {
      margin.value = `${spacing}px`
    } else if (spacing?.endsWith('px')) {
      // TODO: allow for other units
      margin.value = spacing
    }

    return margin.value
  })
}

export function useStackingClasses(props: StackingProps) {
  return computed(() => {
    const { spacing, align, fill } = props

    const classes = ref<string[]>([])

    if (fill) classes.value.push('-fill')

    if (spacing === 'between') classes.value.push('justify-between')
    if (spacing === 'around') classes.value.push('justify-around')
    if (spacing === 'even') classes.value.push('justify-evenly')
    if (spacing === 'center') classes.value.push('justify-center')

    if (align === 'leading') classes.value.push('items-start')
    if (align === 'center') classes.value.push('items-center')
    if (align === 'trailing') classes.value.push('items-end')
    return classes.value
  })
}
